/**
 * Application-wide constants
 */

export const STORAGE_KEYS = {
  TOKEN: "token",
  USER_DATA: "data",
} as const;

export const USER_TYPES = {
  ADMIN: "ADMIN",
  USER: "USER",
  EXTERNAL: "EXTERNAL",
} as const;

export const CUSTOMER_TYPES = {
  INDIVIDUAL: "individual",
  COMPANY: "company",
} as const;

export const TOAST_MESSAGES = {
  LOGIN_SUCCESS: {
    title: "Successfully Logged In!",
    description: "Welcome back",
  },
  LOGIN_ERROR: {
    title: "Login Failed",
    description: "Please check your credentials",
  },
  NETWORK_ERROR: {
    title: "Network Error",
    description: "Please check your internet connection",
  },
  LOADING: {
    title: "Logging in...",
    description: "Please wait",
  },
} as const;

export const VALIDATION_MESSAGES = {
  REQUIRED: "This field is required",
  EMAIL_INVALID: "Please enter a valid email address",
  PHONE_INVALID: "Please enter a valid phone number",
  PASSWORD_MIN_LENGTH: "Password must be at least 8 characters",
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

export const DATE_FORMATS = {
  DISPLAY: "MMM DD, YYYY",
  API: "YYYY-MM-DD",
  DATETIME: "MMM DD, YYYY HH:mm",
} as const;
